module.exports = __webpack_public_path__ + "media/images/img/banner/ccie_kv-2f165725dd1a25d6747152338ffbf2b6.jpg";